/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const ffqSlice = createSlice({
  name: 'ffq',
  initialState: {
    helpdeskPhoneNumber: null,
  } as any,
  reducers: {
    setHelpdeskPhoneNumber: (
      state,
      {
        payload: { helpdeskPhoneNumber },
      }: PayloadAction<{ helpdeskPhoneNumber: string }>,
    ) => {
      state.helpdeskPhoneNumber = helpdeskPhoneNumber
    },
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state.email = ffqSlice.getInitialState().helpdeskPhoneNumber
    })
  },
})

export const { setHelpdeskPhoneNumber } = ffqSlice.actions

export default ffqSlice.reducer
